import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DrawerIframe from "../../common/DrawerIframe";
import { TTP_TEAM_URL } from "../../../config";

const CalendarCollaborator = ({ children, id, name, year }) => {
  const auth = useSelector((state) => state.auth);
  const { loggedAs, spaceAs } = useSelector((state) => state.auth);
  const [fiduciaryId, setFiduciaryId] = useState(null);

  useEffect(() => {
    if (auth.navCommunity) {
      setFiduciaryId(auth.navCommunity.id);
    }
  }, [auth.navCommunity]);

  const params = [];
  let powerTeamUrl =
    loggedAs === "COLLABORATOR" || spaceAs === "COLLABORATOR"
      ? TTP_TEAM_URL + `/collaborator-calendar`
      : TTP_TEAM_URL + `/capacity-planing/collaborator/${name}/${id}/CALENDAR`;

  if (fiduciaryId) {
    params.push("without_header");
    params.push("without_menu");
    params.push("organization_id=" + fiduciaryId);
    params.push("year=" + year);
    return <DrawerIframe src={powerTeamUrl} params={params} />;
  }
  return <></>;
};

export default CalendarCollaborator;
